export default "__VITE_ASSET__N5YZZEzc__"